import { maybeGetGlobal } from '../globals';
var COMMON_CONFIG_NAME = 'commonConfig';
var IGNORE_KEYS = ['consentPolicy', 'consentPolicyHeader'];
var MAP_KEYS = {
    bsi: 'BSI',
};
function extractCommonConfigValues() {
    var globalObj = maybeGetGlobal();
    var commonConfigObj = globalObj === null || globalObj === void 0 ? void 0 : globalObj.commonConfig;
    if (!commonConfigObj) {
        return null;
    }
    var res = {};
    var addedKeys = false;
    Object.keys(commonConfigObj).forEach(function (key) {
        // @ts-ignore
        var newKey = MAP_KEYS[key];
        if (newKey) {
            res[newKey] = commonConfigObj[key];
            addedKeys = true;
        }
        else if (IGNORE_KEYS.indexOf(key) < 0 &&
            typeof commonConfigObj[key] !== 'function') {
            res[key] = commonConfigObj[key];
            addedKeys = true;
        }
    });
    return addedKeys ? res : null;
}
export var commonConfig = function () {
    var _a;
    var commonConfigValues = extractCommonConfigValues();
    var value = commonConfigValues ? JSON.stringify(commonConfigValues) : '';
    return _a = {}, _a[COMMON_CONFIG_NAME] = encodeURIComponent(value), _a;
};
//# sourceMappingURL=common-config.js.map